var React = require('react');

function IcChevronDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.5 5L10.2631 0.5H0.73686L5.5 5Z"}));
}

IcChevronDown.defaultProps = {"width":"11","height":"5","viewBox":"0 0 11 5"};

module.exports = IcChevronDown;

IcChevronDown.default = IcChevronDown;
